// Imports in this file have to relative because import aliases are not supported in Nuxt server

import ServiceBase from '@ekd/portal-connector/dist/Service';

import { getEnv } from '../utils/getEnv';

import { ApiUrls } from '../types/apiUrls';

const allowedCodes = [404, 400, 500, 503, 504];
export default class BaseService extends ServiceBase<ApiUrls> {
  constructor(variables?: { req?: PortalRootIncomingMessage }) {
    super(variables);
    const urls: Record<ApiUrls, string> = {
      'config-api': getEnv('configApi'),
      'feed-api': getEnv('feedApi'),
      'content-api-v3': getEnv('contentApiV3').concat('/graphql'),
      'paywall-api': getEnv('paywallApi').concat('/graphql'),
      'customer-data-api': getEnv('customerDataApi').concat('/graphql'),
      'media-api': getEnv('mediaApi').concat('/graphql'),
      'article-extra-content-api': getEnv('articleExtraContentApi'),
      'orders-api': getEnv('ordersApi'),
      'weather-api': getEnv('weatherApi'),
    };

    this.setApiUrls(urls);
  }

  public generateErrorData(e: any) {
    const extraData = e.debug?.networkError || null;
    const statusCode = extraData?.statusCode || e.statusCode;
    const error = {
      statusCode,
      message: e.message || 'error.unexpected_system_error',
      extraData: extraData?.result?.errors?.length ? JSON.stringify(extraData.result.errors) : '',
    };
    return error;
  }

  public handleError(error?: { statusCode?: number; extraData?: string; message?: string }) {
    const statusCode = error?.statusCode && allowedCodes.includes(error.statusCode) ? error.statusCode : 500;
    throw {
      message: error?.message || 'error.page_not_found',
      statusCode,
      extraData: error?.extraData || '',
    };
  }
}
